import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeOpen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 0H24V24H0V0Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 5,
			fill: "#444444"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.38085 12.7859C1.11846 12.2947 1.11846 11.7053 1.38085 11.2141C3.35086 7.52581 7.36651 5 12 5C16.6335 5 20.6491 7.52581 22.6191 11.2141C22.8815 11.7053 22.8815 12.2947 22.6192 12.7859C20.6491 16.4742 16.6335 19 12 19C7.36651 19 3.35086 16.4742 1.38085 12.7859Z",
			stroke: "#444444",
			strokeWidth: 2
		})
	]
});
export default SvgEyeOpen;
